import { render, staticRenderFns } from "./newStructure.vue?vue&type=template&id=5fdcf952&scoped=true&"
import script from "./newStructure.vue?vue&type=script&lang=js&"
export * from "./newStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdcf952",
  null
  
)

export default component.exports